import React, { useState, useEffect } from "react";
import QRCode from "qrcode";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import ConfigBusiness from "../../commons/config/ConfigBusiness.js";
import { Redirect } from 'react-router-dom'
import {
    TableRow,
} from '@material-ui/core'
import 'moment/min/locales'
import { StyledTableCellProps as StyledTableCell, StyledTooltip } from '../../commons/utils/TableStyles.js'

const SafeFeedbackTipoFormularioGridRow = (props) => {
    const intl = props.intl
    const tipoFormulario = props.tipoFormulario;
    const baseUrl = props.baseUrl;

    const [redirectTo, setRedirectTo] = useState(null)


    useEffect(() => {}, []);

    pdfMake.vfs = pdfFonts.pdfMake.vfs;

    // Genera y descarga el QR en PDF para el tipo de formulario
    const handleDownloadQR = async () => {
        // Puedes personalizar el token o url según el tipo de formulario
        const token = ConfigBusiness.get('reportarIncidentes.tokenUrl');
        const url = `${window.location.origin}/safefeedback-formulario/${tipoFormulario.qr_token}`;

        const qrSize = 700;
        const squareSize = 250;

        const qrDataUrl = await QRCode.toDataURL(url, {
            errorCorrectionLevel: "H",
            margin: 1,
            width: qrSize,
        });

        const loadImageBase64 = async (url) => {
            const res = await fetch(url);
            const blob = await res.blob();
            return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
            });
        };

        const logoBase64 = await loadImageBase64(
            process.env.PUBLIC_URL + "/images/company/logo-login-app.png"
        );

        const canvas = document.createElement("canvas");
        canvas.width = qrSize;
        canvas.height = qrSize;
        const ctx = canvas.getContext("2d");

        const qrImg = new window.Image();
        qrImg.src = qrDataUrl;
        await new Promise((resolve) => (qrImg.onload = resolve));
        ctx.drawImage(qrImg, 0, 0, qrSize, qrSize);

        const logoImg = new window.Image();
        logoImg.src = logoBase64;
        await new Promise((resolve) => (logoImg.onload = resolve));

        const x = (qrSize - squareSize) / 2;
        const y = (qrSize - squareSize) / 2;
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(x, y, squareSize, squareSize);

        const logoAspect = logoImg.width / logoImg.height;
        let logoWidth = squareSize;
        let logoHeight = squareSize;
        if (logoAspect > 1) {
            logoHeight = squareSize / logoAspect;
        } else {
            logoWidth = squareSize * logoAspect;
        }
        const logoX = x + (squareSize - logoWidth) / 2;
        const logoY = y + (squareSize - logoHeight) / 2;
        ctx.drawImage(logoImg, logoX, logoY, logoWidth, logoHeight);

        const qrImgUrl = canvas.toDataURL("image/png");

        const pdfImageWidth = 550;
        const docDefinition = {
            pageSize: "A4",
            pageMargins: [0, 0, 0, 0],
            content: [
                {
                    image: qrImgUrl,
                    width: pdfImageWidth,
                    alignment: "center",
                    margin: [0, 120, 0, 0],
                },
            ],
        };
        pdfMake.createPdf(docDefinition).download(`qr-formulario-${tipoFormulario.id}.pdf`);
    };

    const getEstado = (activo) => {
        if (activo === 1) {
            return "status-green";
        } else if  (activo === 0){
            return "status-red";
        } else {
            return "";
        }
    };

    return (
        <>
            {redirectTo && <Redirect push to={redirectTo} />}
            <TableRow>
                <StyledTableCell align="left">
                    {tipoFormulario.id}
                </StyledTableCell>
                <StyledTooltip arrow placement="right">
                    <td
                        align="left"
                        className={getEstado(tipoFormulario.activo) + " p-0 all custom-lineHeight br"}
                        style={{ maxWidth: "3px"}}
                    />
                </StyledTooltip>
                <StyledTableCell align="left">
                    {tipoFormulario.nombre}
                </StyledTableCell>
                <StyledTableCell align="left">
                     {tipoFormulario.descripcion}
                </StyledTableCell>
                <StyledTableCell>
                    <div className="d-inline-flex">
                        <button
                            className="action view btn btn-sm btn-icon btn-dt-grid text-success"
                            title={intl.formatMessage({ id: "SafeFeedbackTipoFormularioGridRow.ver", defaultMessage: "Ver" })}
                            data-togle="tooltip"
                            data-placement="top"
                            onClick={() => setRedirectTo(baseUrl + '/' + tipoFormulario.id)}
                        >
                            <i className="fa fa-search fa-xs"/>
                        </button>
                        <button
                            className="action edit btn btn-sm btn-icon btn-dt-grid text-success"
                            title={intl.formatMessage({ id: "SafeFeedbackTipoFormularioGridRow.editar", defaultMessage: "Editar" })}
                            data-togle="tooltip"
                            data-placement="top"
                            onClick={()=> setRedirectTo(baseUrl +'/'+ tipoFormulario.id +'/edit')}
                            >
                                <i className="fa fa-pencil fa-xs"/>
                        </button>
                        <button
                            className="btn btn-info btn-sm btn-icon btn-dt-grid text-success"
                            title={intl.formatMessage({ id: "SafeFeedbackTipoFormularioGridRow.descargar_qr", defaultMessage: "Descargar QR" })}
                            onClick={handleDownloadQR}
                        >
                            <i className="fa fa-qrcode fa-xs" style={{ marginRight: 4 }} />
                        </button>
                    </div>
                </StyledTableCell>
            </TableRow>
        </>
    )
}

export default SafeFeedbackTipoFormularioGridRow
